module.exports = __webpack_public_path__ + "91e9fe06bb2dba21038e260252a7a929.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/diamond-shapes/images/pear.png
// module id = 760
// module chunks = 0